import React from 'react';

const PauseCareStats = ({ pauseCareData }) => {
  if (!pauseCareData) return null;

  const renderPauseCareSection = (data, title, bgColor = 'bg-purple-800') => {
    if (!data) return null;

    return (
      <div className="mb-6">
        <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4">
          {title}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {/* User Statistics Section */}
          <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
            <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
              User Statistics
            </h3>
            <div className="grid grid-cols-2 gap-3">
              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Total Users
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.total_users || 0}
                </div>
              </div>

              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Active Users
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.active_users || 0}
                </div>
              </div>

              <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-shoorah-ggg">
                <div className="text-gray-400 dark:text-shoorah-darkBg text-[14px] font-medium">
                  Inactive Users
                </div>
                <div className="text-black dark:text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.inactive_users || 0}
                </div>
              </div>

              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  New Users (30d)
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.new_users_last_30_days || 0}
                </div>
              </div>
            </div>
          </div>

          {/* Pause Care Entries Section */}
          <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
            <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
              Entries
            </h3>
            <div className="grid grid-cols-2 gap-3">
              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Total Entries
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.total_pause_care_entries || 0}
                </div>
              </div>

              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Active Entries
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.active_pause_care_entries || 0}
                </div>
              </div>

              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Total Check-ins
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.total_check_ins || 0}
                </div>
              </div>
            </div>
          </div>

          {/* Check-ins Section */}
          {/* <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
            <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
              Activity
            </h3>
            <div className="grid grid-cols-1 gap-4">
              <div
                className={`h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${bgColor} text-white`}
              >
                <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                  Total Check-ins
                </div>
                <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                  {data.total_check_ins || 0}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <>
      {pauseCareData.menopause &&
        renderPauseCareSection(pauseCareData.menopause, 'Menopause Statistics', 'bg-blue-900')}
      {pauseCareData.andropause &&
        renderPauseCareSection(pauseCareData.andropause, 'Andropause Statistics', 'bg-blue-900')}
    </>
  );
};

export default PauseCareStats;
